// @flow
import { get, attempt } from "lodash";
import mediator from "@tvg/mediator";
import queryString from "query-string";
import { RaceStatusEnum, RaceProgram } from "@tvg/ts-types/Race";
import { RACE_STATUS_MAPPER } from "@tvg/amplitude/constants";

type Props = {
  race: RaceProgram,
  location: {
    pathname: string,
    search: string,
    hash: string
  }
};

export const sendRacePageView = (props: Props) => {
  const pathname = get(props, "location.pathname", "");
  const search = get(props, "location.search", "");
  const hash = get(props, "location.hash", "");
  const pathnameSplitted = pathname.split("/");
  const raceStatusCode = get(props, "race.status.code");
  const mtp = get(props, "race.mtp", 0);
  attempt(() => {
    const trackName =
      typeof pathnameSplitted[3] !== "undefined" ? pathnameSplitted[3] : "";
    const urlParams = queryString.parse(get(props, "location.search"));

    const oldRaceNumber =
      typeof pathnameSplitted[4] !== "undefined" &&
      pathnameSplitted[4].includes("-")
        ? pathnameSplitted[4].split("-")[1]
        : "";

    const raceNumber =
      urlParams && urlParams.race ? urlParams.race : oldRaceNumber;
    mediator.base.dispatch({
      type: "LOAD:RACE_PAGE_VIEW",
      payload: {
        loginStatus: get(props, "isUserLogged", false)
          ? "Logged In"
          : "Logged Out",
        accountId: get(props, "accountNumber") || undefined,
        page: pathname + search + hash,
        raceNumber,
        trackName,
        raceStatus: RACE_STATUS_MAPPER[raceStatusCode] ?? "",
        mtp:
          raceStatusCode === RaceStatusEnum.RACE_OFFICIAL
            ? "resulted"
            : mtp.toString(),
        racingId: get(props, "racingId", "").toString()
      }
    });
  });
};
